import React, { useEffect, useRef, useState } from "react";

const {
  bpopbLogoWhite
} = window.NAV_ICONS;

const Navbar = () => {
  const [busMenuOpen, setBusMenuOpen] = useState(false);

  const busMenuRef = useRef(null);

  const closeBusMenu = () => {
    localStorage.clear();
    setBusMenuOpen(false);
  };

  const handleRouteMenuClick = () => {
    setBusMenuOpen((prev) => !prev);
  };

  useEffect(() => {
    const closeDropdown = (e) => {
      if (busMenuOpen && !busMenuRef.current.contains(e.target)) {
        setBusMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", closeDropdown);

    return () => document.removeEventListener("mousedown", closeDropdown);
  }, [busMenuOpen]);

  return (
    <>
      <nav
        className="px-10 py-3 text-center flex flex-col sm:flex-row justify-between items-center
        bg-accent-fore text-white sticky top-0 z-10 shadow-[0_1px_5px_rgba(0,0,0)]"
      >
        <a href="/" className="block font-light text-xl py-2">
          <img
            src={bpopbLogoWhite}
            alt="Banglar Transit"
            className="p-2 sm:p-0 w-[200px] sm:w-[180px]"
          />
        </a>

        <div className="flex gap-10 md:gap-8 items-center">
          <a
            href="/search-for-routes"
            className="py-2 hover:font-semibold sm:text-lg"
          >
            Search for routes
          </a>

          <a
            href="/kolkata-trams"
            onClick={closeBusMenu}
            className="py-2 hover:font-semibold sm:text-lg"
          >
            Trams
          </a>

          <span
            onClick={handleRouteMenuClick}
            onKeyDown={handleRouteMenuClick}
            role="link"
            tabIndex={0}
            className="py-2 hover:cursor-pointer hover:font-semibold sm:text-lg"
          >
            Bus Explorer
          </span>
        </div>
      </nav>

      {busMenuOpen && (
        <div
          className="h-max w-full sm:w-[420px] bg-accent-back fixed md:top-[80px] sm:right-10
                     z-20 rounded-sm drop-shadow-md p-6 flex flex-col gap-4"
          ref={busMenuRef}
        >
          <div>
            <div className="mb-4 font-semibold">
              Private bus services (Kolkata and Howrah)
            </div>

            <a
              href="/general-private-buses-kolkata-howrah"
              onClick={closeBusMenu}
              className="block my-2 hover:font-semibold hover:text-rose-700"
            >
              General buses
            </a>

            <a
              href="/district-series-buses-kolkata-howrah"
              onClick={closeBusMenu}
              className="block my-2 hover:font-semibold hover:text-rose-700"
            >
              District Series buses
            </a>

            <a
              href="/miscellaneous-private-buses-kolkata-howrah"
              onClick={closeBusMenu}
              className="block my-2 hover:font-semibold hover:text-rose-700"
            >
              Miscellaneous (Unnumbered + AC)
            </a>
          </div>

          <div>
            <div className="mb-4 font-semibold">
              Private bus services (Other Districts)
            </div>

            <a
              href="/general-private-buses-other-districts"
              onClick={closeBusMenu}
              className="block my-2 hover:font-semibold hover:text-rose-700"
            >
              General buses
            </a>
          </div>

          <div>
            <div className="mb-4 font-semibold">
              Government bus services (Kolkata and Howrah)
            </div>

            <a
              href="/government-non-ac-buses-kolkata-howrah"
              onClick={closeBusMenu}
              className="block my-2 hover:font-semibold hover:text-rose-700"
            >
              WBTC Non AC Buses
            </a>

            <a
              href="/government-ac-buses-kolkata-howrah"
              onClick={closeBusMenu}
              className="block my-2 hover:font-semibold hover:text-rose-700"
            >
              WBTC AC Buses
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
